import styled from 'styled-components';

const Spacer = styled.div<{ v: string }>`
  height: ${(props) => (props.v ? props.v : '0')};
`;

export default Spacer;
